import { BankIDTransactionStatus } from '@/types/api/bankid/v1/bankid-transaction-status.enum';
import { BankIDDevice } from '@/types/bankid/bankid-device.enum';

// @ts-ignore
import SettingsGeneralIcon from '@/images/shared/settings/general-icon.svg?react'; // @ts-ignore
import GroupSettingsAddressIcon from '@/images/group/settings/address-icon.svg?react'; // @ts-ignore
import GroupSettingsPayoutIcon from '@/images/group/settings/payout-icon.svg?react'; // @ts-ignore
import UserSettingsMembershipsIcon from '@/images/user/settings/memberships-icon.svg?react';
//import GroupSettingsLeadersIcon from '@/images/group/settings/leaders-icon.svg?react';
// @ts-ignore
import UserSettingsSecurityIcon from '@/images/user/settings/security-icon.svg?react';

export default {
  paymentflow: {
    timeout: 1000 * 60 * 3.5,
    pollInterval: 1500,
    callbackUrl: import.meta.env.VITE_HOST + '/callback',
  },
  orderValidation: {
    timout: 15000,
    pollInterval: 500,
  },

  bankid: {
    poll: { interval: 1000 * 1, timout: 1000 * 60 * 2 },
    messages: {
      [BankIDTransactionStatus.Pending]: {
        [BankIDDevice.This]: {
          message: 'Klicka på knappen och verifiera dig med BankID.',
          switchButton: 'BankID på annan enhet? Visa QR-kod istället.',
        },
        [BankIDDevice.Other]: {
          message: 'Öppna BankID-appen på din mobil och scanna QR-koden för att verifiera din identitet.',
          switchButton: 'BankID på denna enhet?',
        },
      },
    },
  },

  group: {
    settings: {
      links: [
        { to: 'general', label: 'Allmänt', Icon: SettingsGeneralIcon },
        // { to: 'address', label: 'Adress', Icon: GroupSettingsAddressIcon },
        { to: 'payout', label: 'Utbetalning', Icon: GroupSettingsPayoutIcon },
        // { to: 'leaders', label: 'Gruppledare', Icon: GroupSettingsLeadersIcon },
      ],
    },
  },

  user: {
    settings: {
      links: [
        { to: 'general', label: 'Allmänt', Icon: SettingsGeneralIcon },
        { to: 'groups', label: 'Grupper', Icon: UserSettingsMembershipsIcon },
        { to: 'security', label: 'Säkerhet', Icon: UserSettingsSecurityIcon },
        // { to: 'parentship', label: 'Föräldrahjälp', Icon: GroupSettingsPayoutIcon },
      ],
    },
  },
};
